<div class="assets hide white-bg dropdown-shadow">
    <div class="title">
        <h2>Day wise alerts count</h2>
        <p>past 30 days (21 Jun to 20 Jul)</p>
    </div>

    <div id="chart"></div>
</div>

<div class="login-container white-bg">
    <!-- <app-overlay-select [data]="getActions()" [formControl]="action"></app-overlay-select>
    <app-overlay-select *ngIf="action.value" [data]="getreason(action.value)"></app-overlay-select> -->
    <div class="body-wrapper white-bg">
        <div class="body-left-wrapper mt-9">
            <div *ngIf="forgotPwdState==0" class="body-left mx-9 my-10 " [formGroup]="loginForm">
                <!-- <div>
                </div> -->
                <div class="welcome">
                    <div class="body-left-row2 ">
                        <h2 class="lightest-text"> Welcome to</h2>
                    </div>
                    <div class="body-left-row3 ">
                        <div class="logo">
                            <img class="icon-xxl seal" src="assets/Seal_of_Maharashtra.svg">
                            <!-- <img class=" seal" src="assets/secureinteli_logo.png"> -->
                        </div>
                        <div class="title">
                            <div class="body-left-row3-col1">
                                <!-- <img src="assets/user-login/logo_1.svg"> -->
                                <h1 class="bolder-text">Managed Security Services (MSS)</h1>
                            </div>
                            <div class="body-left-row3-col2">
                                <!-- <img src="assets/user-login/siem_1.svg"> -->
                                <p class="content-xl magenta-text bolder-text">Directorate of Information Technology</p>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="body-left-row4 pb-4 ">
                    <p class="content-l primary-text">Log in to explore security events and alerts with ease and perform indepth analysis</p>
                </div>
                <div class="body-left-row5 ">
                    <input class="input-m input-border" type="text" placeholder="Username" formControlName="userName" (keydown)="onKeyDown_UName($event)" #UName>
                </div>
                <div class="body-left-row5 ">
                    <input class="input-m input-border" type="password" placeholder="Password" formControlName="pwd" (keydown)="onKeyDown_pwd($event)" #pwd>
                </div>

                <div class="footer-button">
                    <div class="body-left-row7">
                        <button class="signin submit bold-text content-m white-text" (click)="login()" #signIn>SIGN IN</button>
                    </div>

                    <div class="forgot-password">
                        <span (click)="forgotPassword_click()" class="span-m selectable-text light-text">Forgot password?</span>
                    </div>
                </div>

                <div class="alert-message-row8">
                    <span class="error-message span-l alert-text">{{errorMessage}}</span>
                </div>


            </div>
            <div *ngIf="forgotPwdState==1" class="body-left-forgot my-10" [formGroup]="pwdVerify">

                <!-- <div> -->

                <!-- </div> -->
                <div class="body-left-row2">
                    <p align="center" class="content-l bolder-text black-text"> Welcome to</p>
                </div>

                <div class="body-left-row3">
                    <div class="body-left-row3-col1">
                        <img src="assets/user-login/logo.svg">
                    </div>
                    <div class="body-left-row3-col2">
                        <img class="mb-1" src="assets/user-login/siem.svg">
                    </div>
                </div>
                <!-- <div> -->

                <!-- </div> -->
                <div class="body-left-row4 pb-4">
                    <label class="label-text bold-text span-l">{{qtnList.qtn1}}
                        <span>*</span>
                    </label>
                    <div class="input-box-type">
                        <input class="input-m input-border" type="text" placeholder="Answer the question" formControlName="ans1" (keydown)="clearErrormsg()">
                    </div>
                    <div class="alert-danger content-s alert-text">
                        <div *ngIf="ans1.touched||showForgotError"> {{ validationData.secret_ques.errors | oneError : ans1.errors }}
                        </div>
                    </div>
                </div>
                <div class="body-left-row5">
                    <label class="label-text bold-text span-l">{{qtnList.qtn2}}
                        <span>*</span>
                    </label>
                    <div class="input-box-type">
                        <input class="input-m input-border" type="text" placeholder="Answer the question" formControlName="ans2" (keydown)="clearErrormsg()">
                    </div>
                    <div class="alert-danger content-s alert-text">
                        <div *ngIf="ans2.touched||showForgotError">
                            {{ validationData.secret_ques.errors | oneError : ans2.errors }}
                        </div>
                    </div>
                </div>
                <div class="body-left-row6 pb-4">
                    <div class="body-left-row6-row1">
                        <label class="label-text bold-text span-l">{{forgotPwdmetaData.labels[2]}}</label>
                        <p class="content-s primary-text" *ngIf="timerState">{{forgotPwdmetaData.labels[3]}}</p>
                        <div class="body-left-row6-row1-row1" *ngIf="!timerState">
                            <p class="content-s header-text">{{forgotPwdmetaData.labels[3]}}</p>
                            <span class="primary-text span-l" *ngIf="display!=''"> OTP expire in</span>
                        </div>
                    </div>

                    <div class="body-left-row6-row2">
                        <div>
                            <div class="input-box-type">
                                <input class="input-m input-border" type="text" placeholder="Enter code" formControlName="verificationCode" (keydown)="clearErrormsg()">

                            </div>
                            <div class="alert-danger content-s alert-text">
                                <div *ngIf="verificationCode && verificationCode.errors && (verificationCode.dirty || verificationCode.touched)||showForgotError">
                                    {{ forgotPwdmetaData.verifyCode | oneError : verificationCode.errors }}
                                </div>
                            </div>
                        </div>
                        <button *ngIf="timerState" class="resend-btn submit" (click)="resend_click()">
                            Resend
                        </button>
                        <div class="otp-container p-3" *ngIf="!timerState">
                            <span class="timer span-l bold-text">
                                {{display}}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- <ng-container *ngIf="mat_spinner_forgotpwd_state">
                    <div class="body-bottom-spinner">
                        <mat-spinner class="spinner" diameter=20></mat-spinner>
                    </div>
                </ng-container> -->

                <div class="body-left-row7">
                    <div class="submit-cancel">
                        <button class="cancel" (click)="cancel_click()" mat-dialog-close>
                            Cancel
                        </button>
                        <button class="submit" (click)="load_setNewPassword()">
                            Submit
                        </button>
                    </div>
                </div>
                <div class="alert-message-row8">
                    <span class="error-message alert-text span-l">{{errorMessage}}</span>
                </div>
            </div>

            <div *ngIf="forgotPwdState==2" class="body-left-new-pwd" [formGroup]="setPwd">

                <div>

                </div>
                <div class="body-left-row2">
                    <p align="center" class="content-l bolder-text"> Welcome to</p>
                </div>

                <div class="body-left-row3">
                    <div class="body-left-row3-col1">
                        <img src="assets/user-login/logo.svg">
                    </div>
                    <div class="body-left-row3-col2">
                        <img src="assets/user-login/siem.svg">
                    </div>
                </div>
                <div>

                </div>

                <div class="body-left-row4 pb-4">
                    <label class="body-left-row4-row1 content-l bold-text label-text">{{newPwdmetaData.labels[1]}} <span>*</span> </label>
                    <div class="body-left-row4-row2">
                        <div class="body-left-row4-row2-col1">
                            <input class="input-border" [type]="showPass1?'text':'password'" placeholder="Enter password" formControlName="newPwd">
                        </div>
                        <div class="body-left-row4-row2-col2">
                            <img class="preview-hide-1" src="assets/preview_hide.svg" (click)="showPass1 =! showPass1" *ngIf="!showPass1">
                            <img class="preview-1" src="assets/preview.svg" (click)="showPass1 =! showPass1" *ngIf="showPass1">
                        </div>

                    </div>
                    <div class="alert-danger content-s alert-text" id="alertdanger">
                        <div *ngIf="newPwd.touched||showNewPassError">{{validationData.password.errors |oneError:newPwd.errors}}
                        </div>
                    </div>
                </div>


                <div class="body-left-row5">
                    <label class="body-left-row5-row1 content-l bold-text label-text">{{newPwdmetaData.labels[2]}}
                        <span>*</span>
                    </label>
                    <div class="body-left-row5-row2">

                        <div class="body-left-row5-row2-col1">
                            <input class="input-border" [type]="showPass2?'text':'password'" placeholder="Reenter password" formControlName="reEnterPwd">
                        </div>
                        <div class="body-left-row5-row2-col2">
                            <img class="preview-hide-2" src="assets/preview_hide.svg" (click)="showPass2 =! showPass2" *ngIf="!showPass2">
                            <img class="preview-2" src="assets/preview.svg" (click)="showPass2 =! showPass2" *ngIf="showPass2">
                        </div>

                    </div>
                    <div class="alert-danger content-s alert-text" *ngIf="reEnterPwd.touched || showNewPassError">
                        <div *ngIf="reEnterPwd.invalid">{{validationData.password.errors |oneError:reEnterPwd.errors}}</div>
                        <div *ngIf="reEnterPwd.invalid && reEnterPwd.errors.confirmedValidator">
                            {{validationData.password.errors.pwdnotmatch}}</div>
                    </div>
                </div>
                <div class="body-left-row6 pb-4">
                </div>

                <div class="body-left-row7">
                    <div class="submit-cancel">
                        <button class="cancel" (click)="cancel_click()" mat-dialog-close>
                            Cancel
                        </button>
                        <button class="submit" (click)="submit_click()">
                            Submit
                        </button>
                    </div>
                </div>


                <div class="alert-message-row8 span-l alert-text">
                    <span class="error-message span-l alert-text">{{errorMessage}}</span>
                </div>


            </div>
        </div>

        <div class="body-right">
            <!-- <img src="assets/user-login/lines.jpg"> -->
        </div>
    </div>
    <ng-container *ngIf="mat_spinner_forgotpwd_state">
        <div class="body-bottom-spinner">
            <mat-spinner class="spinner" diameter=20></mat-spinner>
        </div>
    </ng-container>

</div>
<ng-container *ngIf="sharedService.mat_spinner_login_state">
    <div class="spinner-background">
        <div class="inner-spinner">
            <mat-spinner class="spinner" diameter="40"></mat-spinner>
            <p class="primary-text">Loading...</p>
        </div>
    </div>
</ng-container>